import { useState, Fragment } from "react";
import _ from "lodash";
import { ArrowPathIcon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Divider } from "../components/UI/divider";
import { Subheading } from "../components/UI/heading";
import { Input } from "../components/UI/input";
import { Text } from "../components/UI/text";

function InverseText({children}) {
  return (<div className="font-bold text-center bg-black text-white">{children}</div>);
}

export default function SysAdmin() {
  const PRODUCER = "PRODUCER";
  const STYLE = "STYLE";
  const PRODUCERS = [
    {name: "Eaglemount", beverageCount: 8},
    {name: "Lost Cabin", beverageCount: 10},
    {name: "Stone", beverageCount: 4}
  ];
  const STYLES = [
    {name: "Amber Ale", beverageCount: 3},
    {name: "Dubbel", beverageCount: 22},
    {name: "English Bitter", beverageCount: 3},
    {name: "Red Ale", beverageCount: 1}
  ];
  const BEVERAGES = [
    {name: "Green Farmer"},
    {name: "Heather Hill"},
    {name: "Dunkel Weizen"}
  ];
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedBeverages, setSelectedBeverages] = useState([]);
  const [selectedTabName, setSelectedTabName] = useState(PRODUCER);
  const [pendingActionDescription1, setPendingActionDescription1] = useState("");
  const [pendingActionDescription2, setPendingActionDescription2] = useState("");

  function resolveBgColor(itemType) {
    switch(itemType) {
      case PRODUCER:
        return "bg-blue-100";
      case STYLE:
        return "bg-green-100";
      default:
        return "bg-gray-300";
    }
  }

  function SelectedItemDetails({item}) {
    return (<div className={clsx(resolveBgColor(item.itemType), "h-[8rem]")}>
      <div>
        <button title="Delete" className="float-right mt-1 place-items-center w-[2rem] bg-red-300 text-md text-white rounded-[0.5rem]" onClick={() => onDelete(item)}>
          <XMarkIcon />
        </button>
        {item.itemType === STYLE
          ? (<button title="∆ Parent Styles" className="float-right mt-1 mx-1 p-1 place-items-center w-[6rem] bg-black text-md text-white rounded-[0.5rem]" onClick={() => onChangeParentStyles(item)}>
              ∆ Parent Styles
            </button>)
          : null
        }                  
      </div>
      <div className="clear-both">{item.name} Details</div>
    </div>);
  }

  function onDelete(item) {
    // TODO:
  }

  function onDeleteBeverage(item) {
    // TODO:
  }

  function onChangeBeverageType(item) {
    // TODO:
  }

  function onChangeProducer(item) {
    // TODO:
  }

  function onChangeParentStyles(item) {
    // TODO:
  }

  function onSelect(listType, item = null) {
    setSelectedTabName(listType);
    if (item) {
      const newItem = {...item, itemType: listType};
      setSelectedItems([newItem]);
    } else {
      setSelectedItems([]);
    }
    setSelectedBeverages([]);
    setPendingActionDescription1("");
    setPendingActionDescription2("");
  }

  function onSelectBeverage(item) {
    if (item) {
      setSelectedBeverages([item]);
    } else {
      setSelectedBeverages([]);
    }
    setPendingActionDescription2("");
  }

  const selectedItem = selectedItems.length
    ? selectedItems[0]
    : null;
  const selectedBeverage = selectedBeverages.length
    ? selectedBeverages[0]
    : null;

  function resolvePendingAction(newList) {
    if (newList.length > 1) {
      const lastIndex = newList.length - 1;
      const allButLastItemNamesCSV = _.chain(newList)
        .filter((si, idx) => idx !== lastIndex)
        .map(si => si.name)
        .value()
        .join(", ");
      return `Merge ${allButLastItemNamesCSV} into ${newList[newList.length - 1].name}`;
    }
    return ""
  }

  function onAdditionalSelect(listType, item) {
    if (!selectedItem || selectedItem.itemType !== listType)
      return;
    let newList = null;
    if (_.some(selectedItems, si => si.name === item.name)) {
      newList = _.reject(selectedItems, si => si.name === item.name);
    } else {
      const newItem = {...item, itemType: listType};
      newList = [...selectedItems, newItem];
    }
    setSelectedItems(newList);
    setPendingActionDescription1(resolvePendingAction(newList));
  }

  function onMerge() {
    // TODO:
  }

  function onRefresh() {
    // TODO:
  }

  function onAdditionalSelectBeverage(item) {
    if (!selectedBeverage)
      return;
    let newList = null;
    if (_.some(selectedBeverages, sb => sb.name === item.name)) {
      newList = _.reject(selectedBeverages, sb => sb.name === item.name);
    } else {
      newList = [...selectedBeverages, item];
    }
    setSelectedBeverages(newList);
    setPendingActionDescription2(resolvePendingAction(newList));
  }

  const producerBgColor = resolveBgColor(PRODUCER);
  const styleBgColor = resolveBgColor(STYLE);
  const beverageBgColor = resolveBgColor("BEVERAGE");
  return (
    <div className="ms-12">
      <h2 className="text-3xl text-orange-700 font-bold m-3">System Administration</h2>
      <Divider className="my-6" />
      <div className="grid grid-cols-10 mb-4 gap-2">
        <div className="col-span-2 border-b mb-2 border-gray-200 dark:border-gray-700">
          <ul className="flex flex-wrap -mb-px text-sm font-medium text-xl text-center text-gray-500 dark:text-gray-400">
            <li className={clsx({
              "text-red-700": selectedTabName === PRODUCER, 
              "border-t": selectedTabName === PRODUCER
            }, "me-2 border-red-700")}>
              <a
                href="#"
                className="inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
                onClick={() => onSelect(PRODUCER)}>
                  <svg className="w-4 h-4 me-2 group-hover:text-gray-500 dark:group-hover:text-gray-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M5 11.424V1a1 1 0 1 0-2 0v10.424a3.228 3.228 0 0 0 0 6.152V19a1 1 0 1 0 2 0v-1.424a3.228 3.228 0 0 0 0-6.152ZM19.25 14.5A3.243 3.243 0 0 0 17 11.424V1a1 1 0 0 0-2 0v10.424a3.227 3.227 0 0 0 0 6.152V19a1 1 0 1 0 2 0v-1.424a3.243 3.243 0 0 0 2.25-3.076Zm-6-9A3.243 3.243 0 0 0 11 2.424V1a1 1 0 0 0-2 0v1.424a3.228 3.228 0 0 0 0 6.152V19a1 1 0 1 0 2 0V8.576A3.243 3.243 0 0 0 13.25 5.5Z"/>
                  </svg>Producers
              </a>
            </li>
            <li className={clsx({
                "text-red-700": selectedTabName === STYLE, 
                "border-t": selectedTabName === STYLE
              }, "me-2 border-red-700")}>
                <a 
                  href="#"
                  className="inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group"
                  onClick={() => onSelect(STYLE)}>
                    <svg className="w-4 h-4 me-2 group-hover:text-gray-500 dark:group-hover:text-gray-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                      <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z"/>
                    </svg>Styles
                </a>
            </li>
          </ul>
        </div>
        <div className="col-span-7 inline-flex justify-items-center">
          {pendingActionDescription1
            ? (<button className="place-items-center min-w-[30%] bg-orange-700 text-lg text-white rounded-[0.5rem]" onClick={onMerge}>
                {pendingActionDescription1}
              </button>)
            : null
          }
          {pendingActionDescription2
            ? (<button className="ms-3 place-items-center min-w-[30%] bg-red-700 text-lg text-white rounded-[0.5rem]" onClick={onMerge}>
                {pendingActionDescription2}
              </button>)
            : null
          }
        </div>
        <div className="col-span-1">
          <button title="Refresh" className="float-right p-2 mt-4 mr-3 place-items-center w-[50px] bg-black text-sm text-white rounded-[0.5rem]" onClick={onRefresh}>
            <ArrowPathIcon />
          </button>
        </div>
      </div>
      <div className="grid grid-cols-10 mb-4 gap-2">
        <div className="col-span-2">
          {selectedTabName === PRODUCER
            ? (<div>
                {_.map(PRODUCERS, p => {
                  const isSelectedItem = selectedItem && _.some(selectedItems, si => si.name === p.name);
                  return (<div className={clsx({
                            "font-bold": isSelectedItem,
                            "bg-yellow-200": isSelectedItem
                          }, "cursor-pointer ps-2 border-t border-gray-400", (isSelectedItem ? null : producerBgColor))}
                          onClick={(e) => e.ctrlKey ? onAdditionalSelect(PRODUCER, p) : onSelect(PRODUCER, p)}>
                          {p.name} ({p.beverageCount})
                        </div>);
                  })}               
              </div>)
            : null
          }
          {selectedTabName === STYLE
            ? (<div>
                {_.map(STYLES, s => {
                  const isSelectedItem = selectedItem && _.some(selectedItems, si => si.name === s.name);
                  return (<div className={clsx({
                            "font-bold": isSelectedItem,
                            "bg-yellow-200": isSelectedItem
                          }, "cursor-pointer ps-2 border-t border-gray-400", (isSelectedItem ? null : styleBgColor))}
                          onClick={(e) => e.ctrlKey ? onAdditionalSelect(STYLE, s) : onSelect(STYLE, s)}>
                          {s.name} ({s.beverageCount})
                        </div>);
                  })}
              </div>)
            : null
          }
        </div>
        <div className="col-span-2">
          {selectedItem
            ? (<Fragment>
                <InverseText>{selectedItem.name} Beverages</InverseText>
                {_.map(BEVERAGES, b => {
                  const isSelectedItem = selectedBeverage && _.some(selectedBeverages, sb => sb.name === b.name);
                  return (
                  <div className={clsx({
                        "font-bold": isSelectedItem,
                        "bg-yellow-200": isSelectedItem
                      }, "cursor-pointer ps-2 border-t border-gray-400", (isSelectedItem ? null : beverageBgColor))}
                    onClick={(e) => e.ctrlKey ? onAdditionalSelectBeverage(b) : onSelectBeverage(b)}>
                    {b.name}
                  </div>);
                })}
              </Fragment>)
            : (<Text>(Neither a producer nor a style is selected.)</Text>)
          }
        </div>
        {selectedItem
          ? (<div className="col-span-2">
              <InverseText>SELECTED {selectedItem.itemType}</InverseText>
              <SelectedItemDetails item={selectedItem} />
            </div>)
          : null
        }
        {selectedItems.length > 1
          ? (<div className="col-span-2">
              <InverseText>SELECTED {selectedItems[1].itemType} (2)</InverseText>
              <SelectedItemDetails item={selectedItems[1]} />
            </div>)
          : null
        }
        {selectedBeverages.length
          ? (<Fragment>
            {_.map(selectedBeverages, (sb, idx) => (<div className="col-span-2">
                <InverseText>SELECTED BEVERAGE ({idx + 1})</InverseText>
                <div className={clsx(beverageBgColor, "h-[8rem]")}>
                  <div>
                    <button title="Delete" className="float-right mt-1 place-items-center w-[2rem] bg-red-300 text-md text-white rounded-[0.5rem]" onClick={() => onDeleteBeverage(sb)}>
                      <XMarkIcon />
                    </button>
                    <button title="∆ Beverage Type" className="float-right mt-1 mx-1 p-1 place-items-center w-[4rem] bg-black text-md text-white rounded-[0.5rem]" onClick={() => onChangeBeverageType(sb)}>
                      ∆ Type
                    </button>
                    <button title="∆ Producer" className="float-right mt-1 mx-1 p-1 place-items-center w-[6rem] bg-black text-md text-white rounded-[0.5rem]" onClick={() => onChangeProducer(sb)}>
                      ∆ Producer
                    </button>
                  </div>
                  <div className="clear-both">{sb.name} Details</div>
                </div>
              </div>))
            }
            </Fragment>)
          : null
        }
      </div>
    </div>
  );
}